import { useValue } from "@legendapp/state/react";
import { Icon } from "@repo/ui/components/icon";
import { Token } from "@repo/ui/components/token";
import { useSidebarMobileClick } from "@repo/ui/hooks/use-sidebar-mobile-click";
import {
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@repo/ui/ui/sidebar";
import { createLink, useRouterState } from "@tanstack/react-router";

import { connections$ } from "~/stores/connections";
import { datasources$ } from "~/stores/datasources";

const SidebarMenuButtonLink = createLink(SidebarMenuButton);

export const AppSidebarHeader = () => {
  const isSettingsPage = useRouterState({
    select: (s) => s.location.pathname.startsWith("/settings"),
  });

  const handleLinkClick = useSidebarMobileClick("left");

  const datasourceCount = useValue(
    () => Object.keys(datasources$.get() ?? {}).length,
  );

  const connectionCount = useValue(
    () => Object.keys(connections$.get() ?? {}).length,
  );

  return (
    <SidebarHeader>
      <SidebarMenu>
        {isSettingsPage ? (
          <SidebarMenuItem>
            <SidebarMenuButtonLink name="left" to="/" onClick={handleLinkClick}>
              <Icon name="chevron-left" className="text-muted-foreground" />
              Back
            </SidebarMenuButtonLink>
          </SidebarMenuItem>
        ) : (
          <>
            <SidebarMenuItem>
              <SidebarMenuButtonLink
                name="left"
                to="/settings/datasources"
                activeProps={{ isActive: true }}
                onClick={handleLinkClick}
              >
                <Icon name="stack-rounded" className="text-muted-foreground" />
                Datasources
                <Token className="-mr-0.5 ml-auto">{datasourceCount}</Token>
              </SidebarMenuButtonLink>
            </SidebarMenuItem>
            <SidebarMenuItem>
              <SidebarMenuButtonLink
                name="left"
                to="/settings/connections"
                activeProps={{ isActive: true }}
                onClick={handleLinkClick}
              >
                <Icon name="plug" className="text-muted-foreground" />
                Connections
                <Token className="-mr-0.5 ml-auto">{connectionCount}</Token>
              </SidebarMenuButtonLink>
            </SidebarMenuItem>
            <SidebarMenuItem>
              <SidebarMenuButtonLink
                name="left"
                to="/settings/knowledge"
                activeProps={{ isActive: true }}
                onClick={handleLinkClick}
              >
                <Icon name="book" className="text-muted-foreground" />
                Knowledge
              </SidebarMenuButtonLink>
            </SidebarMenuItem>
            <SidebarMenuItem>
              <SidebarMenuButtonLink
                name="left"
                to="/datasets"
                activeOptions={{ exact: true }}
                activeProps={{ isActive: true }}
                onClick={handleLinkClick}
              >
                <Icon name="dot-grid" className="text-muted-foreground" />
                Catalog
              </SidebarMenuButtonLink>
            </SidebarMenuItem>
          </>
        )}
      </SidebarMenu>
    </SidebarHeader>
  );
};
